export const iconFontAwesomeFoodBeverageCubesStacked = (
	<i className="fa-solid fa-cubes-stacked"></i>
);
